export const SET_COMMUNITY_META = "SET_COMMUNITY_META";
export const SET_FLIRTON_POPUP = "SET_FLIRTON_POPUP";

